var mockApis = ['/v2/performance', '/groupPurchase', '/order/detail/v2', '/orders', '/performance/preselectDe', '/calendar', '/calendar/tag'];
export default mockApis;